export default __webpack_public_path__ + "static/media/command.18a384cf.svg";